export const MEMBER_PORTAL_EDITOR_PATH = '/admin/member-portal-editor';

/** Match the editor sidebar alias without granting access to other admin routes. */
export function canAccessMemberPortalEditor(
  visiblePages: readonly string[] | null,
  allowedActions: readonly string[] | null,
): boolean {
  return Boolean(
    allowedActions?.includes('member:portal_manage') &&
    (visiblePages?.includes('/members') || visiblePages?.includes(MEMBER_PORTAL_EDITOR_PATH)),
  );
}
